import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import React from 'react';

const TextSelectorFilterMenu = ({currentFilter, addFilter}) => {
  const handleOnChange = (event) => {
    event.target.value
      ? addFilter(
          {
            ...currentFilter,
            isApplied: true,
            value: event.target.value,
            displayValue: event.target.value,
          },
          false
        )
      : addFilter(
          {
            ...currentFilter,
            isApplied: false,
            value: '',
            displayValue: '',
          },
          false
        );
  };
  return (
    <Box>
      <TextField
        sx={{width: '100%'}}
        value={currentFilter?.value}
        size="small"
        placeholder="add text"
        onChange={handleOnChange}
      />
    </Box>
  );
};

export default TextSelectorFilterMenu;
